import React from 'react'

export const UserPlaylists = ( props ) => {
  console.log( props )
  return (
    <div>

    </div>
  )
}
